
import React from 'react'

import Autocomplete from 'react-autocomplete'

import ChoiceField from './ChoiceField'
import AutocompleteInput from './AutocompleteInput'


function QueryWidget(
    {xy, type, widgetData, widgetTypes, autocomplete, canDelete,
     onValueChange, onFieldChange, onSubmit, onDelete}
     ) {

    const _onValueChange = function(val) {
        if (onValueChange)
            onValueChange(xy, val, false);
    };

    const _onValueSelect = function(val) {
        if (onValueChange)
            onValueChange(xy, val, true);
    };

    const _onModelChange = function(model) {
        if (onFieldChange) {
            onFieldChange(xy, model, widgetData.flat_field);
        }
    };

    const _onFieldChange = function(flat_field) {
        if (onFieldChange) {
            onFieldChange(xy, widgetData.model, flat_field);
        }
    };

    const _onSubmit = (event) => {
        event.preventDefault();
        if (onSubmit)
            onSubmit(xy);
    };

    const _onDeleteClick = (event) => {
        event.preventDefault();
        if (canDelete && onDelete)
            onDelete(xy);
    };

    let model_choices = widgetTypes.map((w, i)=>(
        [w.model, w.model]
    ));
    let field_types = widgetTypes.filter((w)=>(w.model===widgetData.model));
    field_types[0].fields=field_types[0].fields.filter((f)=> {return !f.hidden})
    let field_choices = field_types[0].fields.map((f, i)=>(
        [f.field, f.name]
    ));

    let input_widget = null;

    if (widgetData.type === "text" || widgetData.type === "year") {
        input_widget = <AutocompleteInput
            items={autocomplete[widgetData.flat_field]}
            value={widgetData.value}
            onValueChange={_onValueChange}
            onSelect={_onValueSelect}
            placeholder={"Suchbegriff"}
        />;
    }

    if (widgetData.type === "bool") {
        input_widget = (
            <select
                value={widgetData.value}
                onChange={(event) => {
                    event.stopPropagation();
                    onValueChange(xy, `${event.target.selectedIndex}`, false);
                }}
            >
                <option value={"0"}>Nein</option>
                <option value={"1"}>Ja</option>
            </select>
        );
    }

    return (
        <div className={"query-widget"}>
            <form onSubmit={_onSubmit}>
                <input type={"submit"} hidden={"hidden"}/>
                <div className={"header"}>
                    <div className={"delete-button" + (canDelete ? "": " inactive")} onClick={_onDeleteClick}/>
                </div>
                <div className={"body"}>
                    <ChoiceField choices={model_choices} value={widgetData.model} onChange={_onModelChange}/>
                    <ChoiceField choices={field_choices} value={widgetData.flat_field} onChange={_onFieldChange}/>
                    {input_widget}
                    {widgetData.error ? <div className={"error"} title={widgetData.error}>{widgetData.error}</div> : null}
                </div>
            </form>
        </div>
    );
}

export default QueryWidget;


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/QueryWidget.js